<template>
    <el-dialog :visible.sync="visible" width="600px" append-to-body @close="close" :close-on-click-modal="false">

        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item :label="$t('lang.单位名称')">
                <el-input v-model="form.name"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleConfirm">{{$t('lang.确定')}}</el-button>
                <el-button @click="close">{{$t('lang.取消')}}</el-button>
            </el-form-item>
        </el-form>

    </el-dialog>
</template>

<script>
    export default {
        name: "UnitAdd",
        data(){
            return {
                visible:false,
                form:{},
                initFrom:{
                    name:''
                }
            }
        },
        methods:{
            open(){
                this.form = JSON.parse(JSON.stringify(this.initFrom));
                this.visible = true;
            },
            close(){
                this.visible = false;
            },
            async handleConfirm(){

                let resp = await  this.$http.post(this.$api.boUnit.add,this.$qs.stringify(this.form));
                if(resp.data.status === 200){
                    this.$emit('finish');
                    this.$store.dispatch('UPDATE_UNIT')
                    this.close();
                }else{
                  if(resp.data.desc === '单位名称已存在') {
                    this.$message.error(this.$t(`lang.${resp.data.desc}`));
                    return;
                  }
                    this.$message.error(resp.data.desc);
                }

            }
        }
    }
</script>

<style scoped>

</style>
